// extracted by mini-css-extract-plugin
module.exports = {"container":"Wi","botCopy":"Xi","links":"Yi"};